"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function createFetchBasedFormFetcher(options) {
    return function (formData, endpoint) { return fetch(endpoint, __assign({ 
        // IMPORTANT: Sitecore's antiforgery tokens require x-www-form-urlencoded to validate correctly.
        body: formData.toUrlEncodedFormData(), method: 'post', 
        // IMPORTANT: Sitecore forms relies on cookies for some state management, so credentials must be included.
        credentials: 'include', headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        } }, options))
        .then(function (res) { return res.json(); })
        .then(function (res) { return res; }); };
}
exports.createFetchBasedFormFetcher = createFetchBasedFormFetcher;
function submitForm(formData, endpoint, options) {
    options = options || {};
    if (!options.fetcher) {
        options.fetcher = createFetchBasedFormFetcher();
    }
    return options.fetcher(formData, endpoint);
}
exports.submitForm = submitForm;
